// hooks/useAlert.js
import { useState, useCallback } from "react";

export const useAlert = () => {
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });

  const showAlert = useCallback((type, message) => {
    setAlert({ show: true, type, message });
  }, []);

  const hideAlert = useCallback(() => {
    setAlert({ show: false, type: "", message: "" });
  }, []);

  return {
    alert,
    showAlert,
    hideAlert,
  };
};